import { uploadStatus } from '@/common/app-file-upload/uploadStatus'

import { AppUploadHandlerMutationTypes } from './mutation_types'
import { AppUploadHandlerState } from './state'

export const mutations: StoreMutations<AppUploadHandlerMutationTypes, AppUploadHandlerState> = {
  [AppUploadHandlerMutationTypes.ADD_FILE_TO_UPLOAD]: function (state, file) {
    state.filesToUpload.push(file)
  },
  [AppUploadHandlerMutationTypes.ADD_TO_QUEUE]: function (state, file) {
    state.uploadQueue.push(file)
  },
  [AppUploadHandlerMutationTypes.INCREMENT_UPLOAD_IN_PROGRESS]: function (state) {
    state.uploadInProgress++
  },
  [AppUploadHandlerMutationTypes.DECREMENT_UPLOAD_IN_PROGRESS]: function (state) {
    state.uploadInProgress--
  },
  [AppUploadHandlerMutationTypes.SET_FILE_STATUS_TO_PENDING]: (state, fileKey) => {
    const fileToChange = state.uploadQueue.find(file => file.key === fileKey)
    if (fileToChange) {
      fileToChange.status = uploadStatus.PENDING
    }
  },
  [AppUploadHandlerMutationTypes.REDO_ALL_ERRORED_DOCUMENTS] (state) {
    state.uploadQueue.forEach(file => {
      if (file.status === uploadStatus.ERROR) {
        file.status = uploadStatus.PENDING
      }
    })
  },
  [AppUploadHandlerMutationTypes.RESET]: (state) => {
    state.filesToUpload = []
    state.uploadInProgress = 0
    state.uploadQueue = []
    state.trayManuallyClosed = false
  },
  [AppUploadHandlerMutationTypes.SET_UPLOAD_HINT] (state, { visible = false, destinationFolder = null, messageType = null }) {
    state.uploadHint = {
      visible,
      destinationFolder,
      messageType,
    }
  },
  [AppUploadHandlerMutationTypes.SET_TRAY_MANUALLY_CLOSED] (state, closed) {
    state.trayManuallyClosed = closed
  },
}
